// extracted by mini-css-extract-plugin
module.exports = {"en-landing-container":"en-landing-container_3ure","other-txt":"other-txt_1auP"};